export const MediaBreakpoints = {
    skyscraper: '(min-width: 1280px)',
    wide: '(min-width: 1024px)',
    medium: '(min-width: 651px)',
    small: '(min-width: 400px)',
};
